import { BrandConfigurationResponse, BrandDetailResponse } from '@ydistri/api-sdk';

export const toBrandDetailResponse = ({
  id,
  name,
  productCount,
}: BrandConfigurationResponse): BrandDetailResponse => ({
  id,
  name,
  productCount,
});
